module.exports = {
          srcSet: __webpack_public_path__ + "public/images/5a8432fbb7393f62b020180e24a14d20-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/5a8432fbb7393f62b020180e24a14d20-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/5a8432fbb7393f62b020180e24a14d20-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/5a8432fbb7393f62b020180e24a14d20-1774.webp"},
          
          width: 1774,
          height: 887
        }